'use client';

import { Listbox } from '@headlessui/react';
import { memo, useMemo } from 'react';
import IconChevronRight from '~/shared/assets/icons/chevron-right.svg';
import { sortingItems } from '../config/sortingItems';
import { useProductSorting } from '../model/hooks';

export default memo(() => {
    const [sorting, setSorting] = useProductSorting();

    const selectedSorting = useMemo(() => {
        return sortingItems.find(item => item.key === sorting);
    }, [sorting]);

    return (
        <>
            <Listbox value={sorting} onChange={setSorting}>
                <div className={'relative flex-1'}>
                    <Listbox.Button
                        type={'button'}
                        className={'block w-full py-2.5 text-center font-700 text-16 text-neutral-500 md:hidden'}
                    >
                        <span className={'block truncate'}>{selectedSorting?.title}</span>
                    </Listbox.Button>
                    <Listbox.Button
                        type={'button'}
                        className={'hidden items-center justify-center gap-x-1 px-6 py-2.5 text-14 md:flex'}
                    >
                        <span className={'block truncate'}>{selectedSorting?.title}</span>
                        <IconChevronRight className={'mb-0.5 h-3.5 w-3.5 stroke-neutral-400'} />
                    </Listbox.Button>
                    <Listbox.Options
                        className={
                            'absolute mt-1 max-h-64 w-full overflow-auto bg-neutral-100 py-1 shadow-lg focus:outline-none'
                        }
                    >
                        {sortingItems.map(item => (
                            <Listbox.Option
                                key={`${item.key}`}
                                className={
                                    'relative cursor-default select-none ui-active:bg-neutral-200 py-2 text-gray-500 ui-active:text-neutral-700'
                                }
                                value={item.key}
                            >
                                <span
                                    className={
                                        'block truncate text-center font-400 ui-selected:font-500 first-letter:uppercase'
                                    }
                                >
                                    {item.title}
                                </span>
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </div>
            </Listbox>
        </>
    );
});
